<div class="row">
  <div class="col-xs-12 col-sm-12 col-md-8 p-0 m-0">
    <app-user-header [selectedHeader]="header" [tableCategory]="creditInvoice"></app-user-header>
    <div class="col-xs-12 col-sm-12 col-md-12 Registration-split" *ngIf="!isForgotPwdClicked && !isForgotPwdLink">
      <h3 class="pdp-title">
        {{ "userRegistration.accountInformation.header" | cxTranslate }}
      </h3>
      <span class="title-sub-notify">{{ baseSiteId=='vsh'?
        ("userRegistration.accountInformation.title" | cxTranslate) :
        ("userRegistration.accountInformation.vaxServeTitle" |
        cxTranslate)
        }}</span>
      <span class="title-sub-heading">{{
        "userRegistration.accountInformation.formTitle" | cxTranslate
        }}</span>
      <!-- <div class="accountNotExist alert alert-danger alert-dismissable getAccAlert"
        [ngClass]="{ 'acc-invalid': billToShipError === true }" *ngIf="errorMsg">
        <span class="dismissible-error-message" *ngIf="!billToShipError">
          {{
          "userRegistration.accountInformation.formValidationMsg" | cxTranslate
          }}</span>
        <span class="dismissible-error-message" *ngIf="billToShipError">
          {{
          "userRegistration.accountInformation.billToShipToValidationMsg"
          | cxTranslate
          }}</span>
      </div> -->
      <form [formGroup]="accountInfoForm" id="accountInfoForm" (ngSubmit)="validateAccountInfo()">
        <div class="col-xs-12 col-sm-6 col-md-6 p0">
          <div id="registerBilling">
            <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                doubleLineContainer
                accountnumber-container
              ">
              <ng-template #accountNumberPopContent>
                If you don't know your account number, please call us at
                <span *ngIf="baseSiteId == 'vsh'">1-800-VACCINE (1-800-822-2463).</span>
                <span *ngIf="baseSiteId == 'vax'">1-800-752-9338.</span>
              </ng-template>
              <label for="accountNumber" class="Fields-label icon-label">{{
                "userRegistration.accountInformation.accountNumber.label"
                | cxTranslate
                }}
              </label>
              <a placement="top" [ngbPopover]="accountNumberPopContent"><img
                  src="../../assets/icons/{{baseSiteId}}/faqs-plum.svg" alt="faq_reg" class="faq" /></a>
              <input id="accountNumber" name="accountNumber" maxlength="10"
                aria-labelledby="accountNumber tooltipFacilityName" type="text" placeholder="XXXXXXXXX"
                class="Fields-input" autocomplete="off" formControlName="accountNumber" data-di-id="#accountNumber"
                (keypress)="numberValidation($event)" />
              <span *ngIf="
                  !accountInfoForm.get('accountNumber').errors?.required &&
                  accountInfoForm.get('accountNumber').invalid &&
                  accountInfoForm.get('accountNumber').touched
                " class="errorMessage">{{
                "userRegistration.accountInformation.accountNumber.validationMessage.acceptsNumberValidation"
                | cxTranslate
                }}</span>
              <span *ngIf="
                  accountInfoForm.get('accountNumber').errors?.required &&
                  !accountInfoForm.get('accountNumber').valid &&
                  accountInfoForm.get('accountNumber').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{
                "userRegistration.accountInformation.requiredMsg" | cxTranslate
                }}
              </span>
            </div>
            <div class="
                col-xs-6 col-sm-6 col-md-12
                p0
                Fields-container
                zip-container
              ">
              <label for="zipCode" class="Fields-label">{{
                "userRegistration.accountInformation.zipCode.label" | cxTranslate
                }}</label>
              <input id="zipCode" name="zipCode" data-valid="valid_zip_canada" type="text" maxlength="10"
                class="Fields-input zipReg" autocomplete="off" formControlName="postalCode" data-di-id="#zipCode"
                appZipMask (keypress)="numberValidation($event)"  />

              <span *ngIf="
                  accountInfoForm.get('postalCode').errors?.pattern &&
                  !accountInfoForm.get('postalCode').valid &&
                  accountInfoForm.get('postalCode').touched
                " class="errorMessage" role="alert" aria-live="assertive">{{
                "userRegistration.accountInformation.zipCode.invalidFormatMsg"
                | cxTranslate
                }}</span>
              <span *ngIf="
                  accountInfoForm.get('postalCode').errors?.required &&
                  !accountInfoForm.get('postalCode').valid &&
                  accountInfoForm.get('postalCode').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{
                "userRegistration.accountInformation.requiredMsg" | cxTranslate
                }}
              </span>
            </div>
            <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
          ">
              <label for="email" class="Fields-label">{{
                "userRegistration.userInformation.email.label" | cxTranslate
                }}</label>
              <input id="email" name="email" type="text" class="Fields-input" autocomplete="off"
                formControlName="email"  />
              <span *ngIf="
                  accountInfoForm.get('email').errors?.required &&
                  !accountInfoForm.get('email').valid &&
                  accountInfoForm.get('email').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{
                "userRegistration.accountInformation.requiredMsg" | cxTranslate
                }}
              </span>
              <span *ngIf="
                  accountInfoForm.get('email').errors?.pattern &&
                  !accountInfoForm.get('email').valid &&
                  accountInfoForm.get('email').touched
                " class="errorMessage" role="alert" aria-live="assertive">{{
                "userRegistration.userInformation.email.invalidEmail"
                | cxTranslate
                }}</span>
              <span *ngIf="isUserEmailExistsBoth && errorMsg" class="errorMessage">
                {{
                "userRegistration.accountInformation.emailRegistered"
                | cxTranslate
                }}
              </span>
            </div>
          </div>
          <!--Render control based on Api validation -->
          <div *ngIf="isAccountNoValidated">
            <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
          " *ngIf="!isUserEmailExistsOne">
              <label for="email" class="Fields-label">{{
                "userRegistration.userInformation.confirmEmail.label" | cxTranslate
                }}</label>
              <input id="email" name="email" type="text" class="Fields-input" autocomplete="off"
                formControlName="confirmEmail"  />
              <span *ngIf="
                  accountInfoForm.get('confirmEmail').errors?.required &&
                  !accountInfoForm.get('confirmEmail').valid &&
                  accountInfoForm.get('confirmEmail').touched &&
                  accountInfoForm.get('confirmEmail').value==''
                " class="defaultMessage" role="alert" aria-live="assertive">{{
                "userRegistration.accountInformation.requiredMsg" | cxTranslate
                }}
              </span>
              <span *ngIf="
              accountInfoForm.get('confirmEmail').value!='' &&
              accountInfoForm.get('confirmEmail').touched &&
                    accountInfoForm?.errors
                      ?.emailsDoNotMatch
                  " class="errorMessage" role="alert" aria-live="assertive">{{
                "userRegistration.userInformation.confirmEmail.emailNotMatch"
                | cxTranslate
                }}</span>
            </div>
            <div class="
        col-xs-12 col-sm-12 col-md-12
        p0
        Fields-container
      ">
              <label for="password" class="Fields-label">{{
                "userRegistration.userInformation.password.label" | cxTranslate
                }}</label>
              <input id="password" name="password" type="password" class="Fields-input" autocomplete="off"
                formControlName="currentPassword" />
              <span *ngIf="
              accountInfoForm.get('currentPassword').errors?.required &&
              !accountInfoForm.get('currentPassword').valid &&
              accountInfoForm.get('currentPassword').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{
                "userRegistration.accountInformation.requiredMsg" | cxTranslate
                }}
              </span>
              <span class="errorMessage" *ngIf="
                  (accountInfoForm.get('currentPassword').dirty || accountInfoForm.get('currentPassword').touched) &&
                  isPasswordInvalid &&
                    accountInfoForm.get('currentPassword').value.length > 0
                  ">{{
                    "userRegistration.userInformation.password.inValidPassword"
                    | cxTranslate
                    }}</span>
              <span *ngIf="
                    !accountInfoForm.get('currentPassword').valid &&
                    !accountInfoForm.get('currentPassword').errors
                      ?.required &&
                    accountInfoForm.get('currentPassword').touched && !isUserEmailExistsOne
                  " class="errorMessage">{{
                "userRegistration.userInformation.password.inValidPassword"
                | cxTranslate
                }}</span>
              <div *ngIf="isUserEmailExistsOne">
                <div class="forgot-pwd"><a (click)="navigateForgotPassword()">Forgot Password</a></div>
                <div>
                  <span *ngIf="
                    !accountInfoForm.get('currentPassword').valid && isExistsPasswordInvalid
                  " class="errorMessage">{{
                    "userRegistration.userInformation.password.inValidPassword"
                    | cxTranslate
                    }}</span>
                </div>
              </div>

            </div>

            <div class="
        col-xs-12 col-sm-12 col-md-12
        p0
        Fields-container
      " *ngIf="!isUserEmailExistsOne">
              <label for="confirmPassword" class="Fields-label">{{
                "userRegistration.userInformation.confirmPassword.label" | cxTranslate
                }}</label>
              <input id="confirmPassword" name="confirmPassword" type="password" class="Fields-input" autocomplete="off"
                formControlName="confirmPassword" />
              <span *ngIf="
              accountInfoForm.get('confirmPassword').errors?.required &&
              !accountInfoForm.get('confirmPassword').valid &&
              accountInfoForm.get('confirmPassword').touched &&
              accountInfoForm.get('confirmPassword').value==''
            " class="defaultMessage" role="alert" aria-live="assertive">{{
                "userRegistration.accountInformation.requiredMsg" | cxTranslate
                }}
              </span>
              <span *ngIf="accountInfoForm.get('confirmPassword').value!='' &&
              accountInfoForm.get('confirmPassword').touched &&
                    accountInfoForm?.errors
                      ?.passwordsDoNotMatch
                  " class="errorMessage">{{
                "userRegistration.userInformation.notMatchMsg" | cxTranslate
                }}</span>
            </div>
          </div>
        </div>
        <div *ngIf="isAccountNoValidated && !isUserEmailExistsOne">
          <div class="col-xs-12 col-sm-4 col-md-4 p0 password-security focusnone" id="passwordDesc" tabindex="-1">
            <span class="security-Notify">{{
              "userRegistration.userInformation.password.passwordRuleSection"
              | cxTranslate
              }}</span>
            <ul class="required-ul">
              <li>
                {{
                "userRegistration.userInformation.password.passwordCondition_1"
                | cxTranslate
                }}
              </li>
              <li>
                {{
                "userRegistration.userInformation.password.passwordCondition_2"
                | cxTranslate
                }}
              </li>
              <li>
                {{
                "userRegistration.userInformation.password.passwordCondition_3"
                | cxTranslate
                }}
              </li>
              <li>
                {{
                "userRegistration.userInformation.password.passwordCondition_4"
                | cxTranslate
                }}
              </li>
            </ul>
          </div>
        </div>
        <div *ngIf="isAccountNoValidated && isUserEmailExistsOne">
          <div class="col-xs-12 col-sm-4 col-md-4 p0 password-security focusnone userexists-password" id="passwordDesc"
            tabindex="-1">
            <span class="security-Notify register-notify">
              {{ baseSiteId=='vsh'?
              ("userRegistration.accountInformation.userRegisteredVsh"
              | cxTranslate) : ("userRegistration.accountInformation.userRegisteredVax"
              | cxTranslate)
              }}
            </span>
          </div>
        </div>
        <hr class="Fields-container-line billingPage" />
         <!-- captcha  -->
         <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container pb-3 captcha-x mb-4">
          <re-captcha 
            *ngIf="recaptchaEnabled"
            [siteKey]="siteKey"
            formControlName="captchaToken" 
            (resolved)="showCaptchaErrorMsg = false"
            >
          </re-captcha>
          <span *ngIf=" showCaptchaErrorMsg" class="defaultMessage" role="alert" aria-live="assertive">{{
            "userRegistration.accountInformation.requiredMsg" | cxTranslate }}
          </span>
        </div>
        <div class="invoice-btngrps">
          <button type="submit" class="btn-primary" data-di-id="di-id-7a6cb2cd-cb37948a">
            {{ "userRegistration.accountInformation.buttonLabel" | cxTranslate }}
          </button>
        </div>
      </form>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 Registration-split password_reset_content"
      *ngIf="isForgotPwdClicked && !isForgotPwdLink">
      <h2>{{ "userRegistration.accountInformation.forgotPasswordTitle" | cxTranslate }}</h2>
      <span>{{ "userRegistration.accountInformation.forgotPasswordSubTitle" | cxTranslate }}</span>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 Registration-split password_reset_content password_reset"
      *ngIf="!isForgotPwdClicked && isForgotPwdLink">
      <h2>{{ "userRegistration.accountInformation.resetPassword" | cxTranslate }}</h2>
      <form [formGroup]="accountInfoForm" id="accountInfoForm" (ngSubmit)="resetPassword()">
        <div class="col-xs-12 col-sm-3 col-md-3 p0">
          <div class="
        col-xs-12 col-sm-12 col-md-12
        p0
        Fields-container
      ">
            <label for="currentPassword" class="Fields-label">{{
              "userRegistration.userInformation.resetPassword" | cxTranslate
              }}</label>
            <input id="currentPassword" name="currentPassword" type="password" class="Fields-input" autocomplete="off"
              formControlName="currentPassword" />
            <span *ngIf="
              accountInfoForm.get('currentPassword').errors?.required &&
              !accountInfoForm.get('currentPassword').valid &&
              accountInfoForm.get('currentPassword').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{
              "userRegistration.accountInformation.requiredMsg" | cxTranslate
              }}
            </span>
            <span *ngIf="
                    !accountInfoForm.get('currentPassword').valid &&
                    !accountInfoForm.get('currentPassword').errors
                      ?.required &&
                    accountInfoForm.get('currentPassword').touched
                  " class="errorMessage">{{
              "userRegistration.userInformation.password.inValidPassword"
              | cxTranslate
              }}</span>
          </div>
          <div class="
        col-xs-12 col-sm-12 col-md-12
        p0
        Fields-container
      ">
            <label for="confirmPassword" class="Fields-label">{{
              "userRegistration.userInformation.resetConfirmPassword" | cxTranslate
              }}</label>
            <input id="confirmPassword" name="confirmPassword" type="password" class="Fields-input" autocomplete="off"
              formControlName="confirmPassword" />
            <span *ngIf="
              accountInfoForm.get('confirmPassword').errors?.required &&
              !accountInfoForm.get('confirmPassword').valid &&
              accountInfoForm.get('confirmPassword').touched &&
              accountInfoForm.get('confirmPassword').value==''
            " class="defaultMessage" role="alert" aria-live="assertive">{{
              "userRegistration.accountInformation.requiredMsg" | cxTranslate
              }}
            </span>
            <span *ngIf="accountInfoForm.get('confirmPassword').value!='' &&
              accountInfoForm.get('confirmPassword').touched &&
                    accountInfoForm?.errors
                      ?.passwordsDoNotMatch
                  " class="errorMessage">{{
              "userRegistration.userInformation.notMatchMsg" | cxTranslate
              }}</span>
          </div>
        </div>
        <div class="col-xs-12 col-sm-4 col-md-4 p0 password-security focusnone password-security-reset"
          id="passwordDesc" tabindex="-1">
          <span class="security-Notify security-Notify-reset">{{
            "userRegistration.userInformation.password.passwordRuleSection"
            | cxTranslate
            }}</span>
          <ul class="required-ul">
            <li>
              {{
              "userRegistration.userInformation.password.passwordCondition_1"
              | cxTranslate
              }}
            </li>
            <li>
              {{
              "userRegistration.userInformation.password.passwordCondition_2"
              | cxTranslate
              }}
            </li>
            <li>
              {{
              "userRegistration.userInformation.password.passwordCondition_3"
              | cxTranslate
              }}
            </li>
            <li>
              {{
              "userRegistration.userInformation.password.passwordCondition_4"
              | cxTranslate
              }}
            </li>
          </ul>
          <span class="security-Notify security-notify-reset1">{{
            "userRegistration.accountInformation.resetPasswordAlert"
            | cxTranslate
            }}&nbsp;<a class="pwd-tooltip" [ngbPopover]="popContentSite" popoverClass="site-popover"
              (mouseenter)="p1.open()" (mouseleave)="p1.close()" #p1="ngbPopover" placement="bottom">other sites</a>
            <ng-template #popContentSite>
              <!-- <div> -->
              <span class="">These sites Includes:</span>
              <li>VaccineShop Canada</li>
              <li>Vaccines.com</li>
              <li>SanofiShoppe</li>
              <li>CEACAM5.com</li>
              <!-- </div> -->
            </ng-template>
          </span>
        </div>
        <hr class="Fields-container-line billingPage" />
        <div class="invoice-btngrps">
          <button type="submit" class="btn-primary">
            {{ "userRegistration.accountInformation.buttonLabel" | cxTranslate }}
          </button>
        </div>
      </form>
    </div>

  </div>

  <div class="col-xs-12 col-sm-12 col-md-4 needCls needCls2" [innerHTML]="(finalNeedAss | async)?.content">
  </div>
</div>
